













import { defineComponent, ref } from '@vue/composition-api'
import { Container, Aside, Main } from 'element-ui'
import LayoutAside from './components/Aside.vue'

export default defineComponent({
    components: {
        [Container.name]: Container,
        [Aside.name]: Aside,
        [Main.name]: Main,
        LayoutAside
    },
    setup() {
        return {}
    }
})
